// One-click Save for a draft skill (29 Oct 2026, Matt's 28 Oct note: saving a
// draft took four steps and left the chat). It stays on Admin → Skills and
// only talks: it never saves, edits or discards a draft.

import type { Walkthrough } from './types'

export const skillDraftSave: Walkthrough = {
  slug: 'skill-draft-save',
  title: 'Save a draft skill in one click',
  summary:
    'Shows the Save button on a draft skill in the Skills list and on the card the agent leaves in the chat. Nothing is saved or changed.',
  added: '2026-10-29',
  steps: [
    {
      page: 'admin-agent-skills',
      feature: 'skills/skills-library',
      say: 'This is the skills library. Your drafts sit at the top of My skills, marked Draft. Only you can see a draft, and the agent does not use it yet.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/save-skill',
      say: 'Each of your drafts has a Save button on its row. One click saves it to My skills, and the agent uses it for you from then on. If you already have a saved skill with that name, the button’s tip says the draft replaces it.',
    },
    {
      page: 'admin-agent-skills',
      feature: 'skills/save-skill',
      say: 'In a chat, when the agent writes a draft for you, a card under its message names the draft with Save to My skills. You can save it there without leaving the chat, or open it in the Skills tab to edit or test it first.',
    },
  ],
}
